/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Window_Resize_RightInputs */

const en_window_resize_right = /** @type {(inputs: Window_Resize_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resize from right edge`)
};

const ar_window_resize_right = /** @type {(inputs: Window_Resize_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تغيير الحجم من الحافة اليمنى`)
};

const bn_window_resize_right = /** @type {(inputs: Window_Resize_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডানের কিনারা থেকে রিসাইজ করুন`)
};

const de_window_resize_right = /** @type {(inputs: Window_Resize_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe vom rechten Rand ändern`)
};

const es_window_resize_right = /** @type {(inputs: Window_Resize_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambiar tamaño desde el borde derecho`)
};

const fr_window_resize_right = /** @type {(inputs: Window_Resize_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionner à partir du bord droit`)
};

const pt_window_resize_right = /** @type {(inputs: Window_Resize_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redimensionar da borda direita`)
};

const zh_window_resize_right = /** @type {(inputs: Window_Resize_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从右边缘调整大小`)
};

const tr_window_resize_right = /** @type {(inputs: Window_Resize_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sağ kenardan yeniden boyutlandır`)
};

const ru_window_resize_right = /** @type {(inputs: Window_Resize_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменение размера от правого края`)
};

const pl_window_resize_right = /** @type {(inputs: Window_Resize_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmień rozmiar od prawej krawędzi`)
};

/**
* | output |
* | --- |
* | "Resize from right edge" |
*
* @param {Window_Resize_RightInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const window_resize_right = /** @type {((inputs?: Window_Resize_RightInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Window_Resize_RightInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_window_resize_right(inputs)
	if (locale === "bn") return bn_window_resize_right(inputs)
	if (locale === "de") return de_window_resize_right(inputs)
	if (locale === "es") return es_window_resize_right(inputs)
	if (locale === "fr") return fr_window_resize_right(inputs)
	if (locale === "pt") return pt_window_resize_right(inputs)
	if (locale === "zh") return zh_window_resize_right(inputs)
	if (locale === "tr") return tr_window_resize_right(inputs)
	if (locale === "ru") return ru_window_resize_right(inputs)
	if (locale === "pl") return pl_window_resize_right(inputs)
	return en_window_resize_right(inputs)
});